import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import SvgIcon from '../SvgIcon';
import { Heading, HeadingLevel } from '@gik/ui';

export interface IAccordionItemProps extends React.HTMLAttributes<HTMLDivElement> {
  header?: React.ReactNode;
  isOpen?: boolean;

  onToggle?(ev?: React.MouseEvent<HTMLDivElement>): void;

  onClick?(ev?: React.MouseEvent<HTMLDivElement>): void;

  headerAsHeading?: boolean;
  headingLevel?: HeadingLevel;
}

export default function AccordionItem({
  header,
  children,
  className,
  isOpen,
  onToggle,
  onClick,
  headerAsHeading = false,
  headingLevel = 2,
  ...otherProps
}: IAccordionItemProps): React.ReactElement {
  const bem = bemBlock('accordion-item');

  function handleToggle(ev: React.MouseEvent<HTMLDivElement>) {
    if (!children) {
      if (onClick) {
        onClick(ev);
      }
      return;
    }
    if (onToggle) {
      onToggle(ev);
    }
  }

  return (
    <div className={bem(null, [{ open: isOpen }], className)} {...otherProps}>
      {header && (
        <section className={bem('header')} onClick={handleToggle}>
          {headerAsHeading ? (
            <Heading level={headingLevel} noStyling className={bem('title')}>
              {header}
            </Heading>
          ) : (
            <span className={bem('title')}>{header}</span>
          )}
          {children && (
            <div className={bem('toggle-icon')}>
              <SvgIcon name="ChevronDown" size="sm" />
            </div>
          )}
        </section>
      )}
      <section className={bem('main')}>{children && <div>{children}</div>}</section>
    </div>
  );
}
